import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from "../app.component";

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  replyContact(data: any) {
    return this.http.post(`${this.baseUrl}/replyContactUS`, data);

  }

  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) { }

  //Dashboard
  getYearWiseCount() {
    return this.http.get(`${this.baseUrl}/getYearWiseCount`);
  }
  getEnggCount() {
    return this.http.get(`${this.baseUrl}/getEnggCount`);
  }
  getAptiCount() {
    return this.http.get(`${this.baseUrl}/getAptiCount`);
  }

  //Contacts
  getAllContacts(token) {
    return this.http.get(`${this.baseUrl}/getAllContactUsAdmin?token=` + token);

  }
  //Events
  getAllEvents(token) {
    return this.http.get(`${this.baseUrl}/getAllEventsAdmin?token=` + token);
  }
  createEvent(token, data) {
    return this.http.post(`${this.baseUrl}/createEvent?token=` + token, data);
  }
  updateEvent(token, data) {
    return this.http.post(`${this.baseUrl}/updateEvent?token=` + token, data);
  }
  deleteEvent(id, token) {
    return this.http.post(`${this.baseUrl}/deleteEvent?token=` + token, id);
  }

  //News
  getAllNews(token) {
    return this.http.get(`${this.baseUrl}/getAllNewsAdmin?token=` + token);
  }
  createNews(token, data) {
    return this.http.post(`${this.baseUrl}/createNews?token=` + token, data);
  }
  updateNews(token, data) {
    return this.http.post(`${this.baseUrl}/updateNews?token=` + token, data);
  }
  deleteNews(id, token) {
    return this.http.post(`${this.baseUrl}/deleteNews?token=` + token, id);
  }

  //Home-Faqs
  getAllFaqs(token) {
    return this.http.get(`${this.baseUrl}/getAllFaqAdmin?token=` + token);
  }
  createFaqs(token, data) {
    return this.http.post(`${this.baseUrl}/createFaq?token=` + token, data);
  }
  updateFaqs(token, data) {
    return this.http.post(`${this.baseUrl}/updateFaq?token=` + token, data);
  }
  deleteFaqs(id, token) {
    return this.http.post(`${this.baseUrl}/deleteFaq?token=` + token, id);
  }

  //Announcements
  getAnnouncement(token) {
    return this.http.get(`${this.baseUrl}/getAllAnnouncementsAdmin?token=` + token);
  }
  deleteAnnouncement(data, token) {
    return this.http.post(`${this.baseUrl}/deleteAnnouncement?token=` + token, data);
  }
  createAnnouncements(token, data) {
    return this.http.post(`${this.baseUrl}/createAnnouncement?token=` + token, data);
  }
  updateAnnouncements(token, data) {
    return this.http.post(`${this.baseUrl}/updateAnnouncement?token=` + token, data);
  }
  hideAnnouncementFromHome(data){
    return this.http.post(`${this.baseUrl}/hideAnnouncementFromHome`,data);
  }
  //Banner
  getBanner(token) {
    return this.http.get(`${this.baseUrl}/getAllBannersAdmin?token=` + token);
  }
  deleteBanner(data, token) {
    return this.http.post(`${this.baseUrl}/deleteBanner?token=` + token, data);
  }
  createBanner(token, data) {
    return this.http.post(`${this.baseUrl}/createBanner?token=` + token, data);
  }
  updateBanner(token, data) {
    return this.http.post(`${this.baseUrl}/updateBanner?token=` + token, data);
  }
  //Topics
  getAllTopics(token) {
    return this.http.get(`${this.baseUrl}/getAllTopicsAdmin?token=` + token);
  }
  createTopic(token, data) {
    return this.http.post(`${this.baseUrl}/addTopic?token=` + token, data);
  }
  updateTopic(token, data) {
    return this.http.post(`${this.baseUrl}/updateTopic?token=` + token, data);
  }
  hideTopic(data, token) {
    return this.http.post(`${this.baseUrl}/hideTopic?token=` + token, data);
  }
  getAllDepartments(token) {
    return this.http.get(`${this.baseUrl}/getAllDepartmentsAdmin?token=` + token);
  }
  // createSyllabus(token, data) {
  //   return this.http.post(`${this.baseUrl}/addSyllabus?token=` + token, data);
  // }
  updateSyllabus(token, data) {
    return this.http.post(`${this.baseUrl}/updateSyllabus?token=` + token, data);
  }

  getSpecificTopic(data){
    return this.http.get(`${this.baseUrl}/getSpecificTopic?id=` + data)
  }

  //Experts
  getAllExperts(token) {
    return this.http.get(`${this.baseUrl}/fetchExpertRecord?token=` + token);
  }
  reopenExpert(id, token) {
    return this.http.post(`${this.baseUrl}/reopenExpert?token=` + token, id);
  }

  // Image-gallery
  getAllImageGallery() {
    return this.http.get(`${this.baseUrl}/getAllImageGallery`);
  }
  createImageGallery(data) {
    return this.http.post(`${this.baseUrl}/createImageGallery`, data);
  }
  updateImageGallery(data) {
    return this.http.post(`${this.baseUrl}/updateImageGallery`, data);
  }
  hideImageGallery(data) {
    return this.http.post(`${this.baseUrl}/deleteImageGallery`, data);
  }

  // Image-gallery
  getAllVideoGallery() {
    return this.http.get(`${this.baseUrl}/getAllVideoGallery`);
  }
  createVideoGallery(data) {
    return this.http.post(`${this.baseUrl}/createVideoGallery`, data);
  }
  updateVideoGallery(data) {
    return this.http.post(`${this.baseUrl}/createVideoGallery`, data);
  }

  hideVideoGallery(data) {
    return this.http.post(`${this.baseUrl}/deleteVideoGallery`, data);
  }

  // Payments
  getAllExpertPayments() {
    return this.http.get(`${this.baseUrl}/getAllExpertPayments`);
  }
  getAllReviewerPayments() {
    return this.http.get(`${this.baseUrl}/getAllReviewerPayments`);
  }

  getTopics() {
    return this.http.get(`${this.baseUrl}/getAllTopics`);
  }

  getSelectedTopic(data) {
    return this.http.get(`${this.baseUrl}/getSelectedTopicAdmin?departments_id=${data}`);
  }

  getDepartment() {
    return this.http.get(`${this.baseUrl}/getAllDepartments`);
  }

  getAllUsers() {
    return this.http.get(`${this.baseUrl}/getAllUsers`);
  }
  updateUserEmail(data) {
    return this.http.post(`${this.baseUrl}/updateUserEmail`,data);
  }

  getUserByEmail(email) {
    return this.http.get(`${this.baseUrl}/getUserByEmail?email=`+email);
  }
  getUserByPhone(phone) {
    return this.http.get(`${this.baseUrl}/getUserByPhone?phone=`+phone);
  }

  // Institute Approval
  getInstitutePending() {
    return this.http.get(`${this.baseUrl}/getInstitutePending`);
  }
  updateInstituteStatus(id, status) {
    return this.http.get(`${this.baseUrl}/updateInstituteStatus?id=${id}&status=${status}`);
  }

  getAdminDepartments(){
    return this.http.get(`${this.baseUrl}/getDepartmentTopics`);
  }

  //Eminents and Unforgettables
  //Banner
  getEminents(token) {
    return this.http.get(`${this.baseUrl}/getAllEminentsAdmin?token=` + token);
  }
  deleteEminents(data, token) {
    return this.http.post(`${this.baseUrl}/deleteEminents?token=` + token, data);
  }
  createEminents(token, data) {
    return this.http.post(`${this.baseUrl}/createEminents?token=` + token, data);
  }
  updateEminents(token, data) {
    return this.http.post(`${this.baseUrl}/updateEminents?token=` + token, data);
  }

  //Scrolling Message
  getAllMessages(token) {
    return this.http.get(`${this.baseUrl}/getAllMessagesAdmin?token=` + token);
  }
  createMessages(token, data) {
    return this.http.post(`${this.baseUrl}/createMessages?token=` + token, data);
  }
  updateMessages(token, data) {
    return this.http.post(`${this.baseUrl}/updateMessages?token=` + token, data);
  }
  deleteMessages(id, token) {
    return this.http.post(`${this.baseUrl}/deleteMessages?token=` + token, id);
  }

  getEligibleInstitutes(token) {
    return this.http.get(`${this.baseUrl}/getEligibleInstitutes?token=` + token);
  }
  updateInstituteEmailId(token, data) {
    return this.http.post(`${this.baseUrl}/updateInstituteEmailId?token=` + token, data);
  }

  // User Management
  getFacultyDetailsAdmin(token) {
    return this.http.get(`${this.baseUrl}/getFacultyDetailsAdmin?token=` + token);
  }
  updateFacultyEmailId(token, data) {
    return this.http.post(`${this.baseUrl}/updateFacultyEmailId?token=` + token, data);
  }

  getDistinctInstitutePid(){
    return this.http.get(`${this.baseUrl}/getDistinctInstitutePid`);
  }
  getFacultyByPid(data){
    return this.http.get(`${this.baseUrl}/getFacultyByPid?pid=`+data);
  }
  getFacultyByEmail(data){
    return this.http.get(`${this.baseUrl}/getFacultyByEmail?email=`+data);
  }

  updateInstituteStatusActive(data) {
    return this.http.post(`${this.baseUrl}/updateInstituteStatusActive`, data);
  }


  // Student - User management
  getStudentDetailsAdmin(token) {
    return this.http.get(`${this.baseUrl}/getStudentDetailsAdmin?token=` + token);
  }
  updateStudentEmailId(token, data) {
    return this.http.post(`${this.baseUrl}/updateStudentEmailId?token=` + token, data);
  }
  getStudentById(data){
    return this.http.get(`${this.baseUrl}/getStudentById?sid=`+data);
  }
  getStudentByEmail(data){
    return this.http.get(`${this.baseUrl}/getStudentByEmail?email=`+data);
  }

  // Expert user management
  getExpertDetailsAdmin(token) {
    return this.http.get(`${this.baseUrl}/getExpertDetailsByAdmin`);
  }
  getExpertByPid(data){
    return this.http.get(`${this.baseUrl}/getExpertByPid?pid=`+data);
  }
  getExpertByEmail(data){
    return this.http.get(`${this.baseUrl}/getExpertByEmail?email=`+data);
  }
  // updateVoluntaryExpertFlag(data){
  //   return this.http.post(`${this.baseUrl}/updateVoluntaryExpertFlag`,data);
  // }
  // setQuestionsLimit(data) {
  //   return this.http.post(`${this.baseUrl}/setQuestionsLimit`, data);
  // }

  // Reviewer user management
  getReviewerDetailsAdmin(token) {
    return this.http.get(`${this.baseUrl}/getReviewerDetailsByAdmin`);
  }
  getReviewerByPid(data){
    return this.http.get(`${this.baseUrl}/getReviewerByPid?pid=`+data);
  }
  getReviewerByEmail(data){
    return this.http.get(`${this.baseUrl}/getReviewerByEmail?email=`+data);
  }
  // updateVoluntaryReviewerFlag(data){
  //   return this.http.post(`${this.baseUrl}/updateVoluntaryReviewerFlag`,data);
  // }

  //Downloads
  getAllDownload(token) {
    return this.http.get(`${this.baseUrl}/getAllDownload?token=` + token);
  }
  deleteDownload(data, token) {
    return this.http.post(`${this.baseUrl}/deleteDownload?token=` + token, data);
  }
  createDownload(token, data) {
    return this.http.post(`${this.baseUrl}/createDownload?token=` + token, data);
  }
  updateDownload(token, data) {
    return this.http.post(`${this.baseUrl}/updateDownload?token=` + token, data);
  }

   //Directory
   getAllDirectory(token) {
    return this.http.get(`${this.baseUrl}/getAllDirectory?token=` + token);
  }
  deleteDirectory(data, token) {
    return this.http.post(`${this.baseUrl}/deleteDirectory?token=` + token, data);
  }
  createDirectory(token, data) {
    return this.http.post(`${this.baseUrl}/createDirectory?token=` + token, data);
  }
  updateDirectory(token, data) {
    return this.http.post(`${this.baseUrl}/updateDirectory?token=` + token, data);
  }

  //Guidelines
  getAllGuidelines(token) {
    return this.http.get(`${this.baseUrl}/getAllGuidelines?token=` + token);
  }
  createGuidelines(token, data) {
    return this.http.post(`${this.baseUrl}/createGuidelines?token=` + token, data);
  }
  updateGuidelines(token, data) {
    return this.http.post(`${this.baseUrl}/updateGuidelines?token=` + token, data);
  }
  deleteGuidelines(id, token) {
    return this.http.post(`${this.baseUrl}/deleteGuidelines?token=` + token, id);
  }

  // Assessments assign
  getAdminStudents(data){
    if(!data){
      return this.http.get(`${this.baseUrl}/getAdminStudents`);
    }else{
      if(data['sid']){
        return this.http.get(`${this.baseUrl}/getAdminStudents?sid=`+data['sid']);
      }else if(data['pid']){
        return this.http.get(`${this.baseUrl}/getAdminStudents?pid=`+data['pid']);
      }else{
        return this.http.get(`${this.baseUrl}/getAdminStudents`);
      }
    }

  }
  makeEligible(data){
    return this.http.post(`${this.baseUrl}/makeAdminEligible`,data);
  }
  updateStudentDates(data){
    return this.http.post(`${this.baseUrl}/updateStudentDatesAdmin`,data);
  }

  //Leadership
  getAllLeadership(token) {
    return this.http.get(`${this.baseUrl}/getAllLeadership?token=` + token);
  }
  deleteLeadership(data, token) {
    return this.http.post(`${this.baseUrl}/deleteLeadership?token=` + token, data);
  }
  createLeadership(token, data) {
    return this.http.post(`${this.baseUrl}/createLeadership?token=` + token, data);
  }
  updateLeadership(token, data) {
    return this.http.post(`${this.baseUrl}/updateLeadership?token=` + token, data);
  }

  getQuestionCounts() {
    return this.http.get(`${this.baseUrl}/getQuestionCounts`);
  }

  assignQuestionsForReview(data) {
    return this.http.post(`${this.baseUrl}/assignQuestionsForReview`,data);
  }

  //Hide Tabs from Reviewer Login

  // hidePaymentTabReviewer(data){
  //   return this.http.post(`${this.baseUrl}/hidePaymentTabReviewer`,data);
  // }

  // hideDashboardTabReviewer(data){
  //   return this.http.post(`${this.baseUrl}/hideDashboardTabReviewer`,data);
  // }

  updateActiveUserEmailId(token, data) {
    return this.http.post(`${this.baseUrl}/updateActiveUserEmailId?token=` + token, data);
  }

}
